// Orval генерирует `{[key: string]: unknown}` для открытых объектов в записи
// потока — сужаем до известной формы бэка здесь, чтобы не кастовать вручную
// в местах использования.

import { stripUndefined } from '@vlabs/monokit/shared/lib/utils';

export interface StreamAnalyticsRecordItem {
  type?: string;
  /** Альтернативное имя типа ВА — записи потоков (enriched=0) могут отдавать только analytic_name. */
  analytic_name?: string;
  label?: string;
  parameters?: unknown;
  event_meta?: unknown;
  schedules?: unknown[];
}

export interface StreamLocationRecord {
  city?: string;
  area?: string;
  district?: string;
  street?: string;
  house_number?: string;
  geo_position?: {
    latitude?: number;
    longitude?: number;
  };
}

export function toStreamAnalyticsRecordItem(value: unknown): StreamAnalyticsRecordItem {
  return (typeof value === 'object' && value !== null) ? value : {};
}

/**
 * Нормализация записи ВА для формы: тип из type или analytic_name
 * (записи потоков enriched=0 могут содержать только analytic_name).
 * Оставляются только известные поля StreamAnalytics — бэк отклоняет
 * неизвестные свойства (напр. analytic_name) в PUT.
 */
export function normalizeStreamAnalyticsRecordItem(value: unknown): StreamAnalyticsRecordItem {
  const record = toStreamAnalyticsRecordItem(value);

  const result: StreamAnalyticsRecordItem = {
    label: record.label,
    type: record.type ?? record.analytic_name,
    parameters: record.parameters,
  };

  // null (напр. event_meta из enriched-ответа) не отправляем: бэк требует объект
  if (record.event_meta != null) result.event_meta = record.event_meta;
  if (record.schedules != null) result.schedules = record.schedules;

  return result;
}

export function toStreamLocationRecord(value: unknown): StreamLocationRecord | undefined {
  if (typeof value !== 'object' || value === null) return undefined;
  const location = value as StreamLocationRecord;
  const geoPosition = location.geo_position as { latitude?: unknown; longitude?: unknown } | undefined;

  return stripUndefined({
    city: typeof location.city === 'string' ? location.city : undefined,
    area: typeof location.area === 'string' ? location.area : undefined,
    district: typeof location.district === 'string' ? location.district : undefined,
    street: typeof location.street === 'string' ? location.street : undefined,
    house_number: typeof location.house_number === 'string' ? location.house_number : undefined,
    geo_position: stripUndefined({
      latitude: typeof geoPosition?.latitude === 'number' ? geoPosition.latitude : undefined,
      longitude: typeof geoPosition?.longitude === 'number' ? geoPosition.longitude : undefined,
    }),
  });
}
